import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons/faEdit';

import Card from 'components/Account/Common/Card/Card';
import FormNewsLetter from './FormNewsletter/FormNewsletter';
import { useCustomer } from 'hooks/useCustomer';
import { replacePhoneNumberWithSpace } from 'services/formatter';
import { getRoutesUri } from 'services/generic';

import styles from './PersonalInformation.module.scss';

function PersonalInformation(): JSX.Element {
  const { t } = useTranslation(['summaryPage']);
  const { customer } = useCustomer();
  const fullName = `${customer?.civility} ${customer?.firstName} ${customer?.lastName}`;
  const customerNumber = customer?.pcle ? customer.pcle.slice(0, -1) : null;
  const phone = customer?.phone
    ? replacePhoneNumberWithSpace(customer?.phone)
    : null;

  const cellPhone =
    customer?.cellPhone && replacePhoneNumberWithSpace(customer?.cellPhone);

  const renderCellPhone = () => {
    if (customer?.cellPhone) {
      return (
        <label>
          {t('LABEL_CELLPHONE')} <span>{cellPhone}</span>
        </label>
      );
    } else {
      return <FormNewsLetter />;
    }
  };

  return (
    <Card classes={{ container: styles.container }}>
      <div className={styles.title}>
        <label>{t('LABEL_INFORMATION_SUBTITLE')}</label>
      </div>
      <div className={styles.content}>
        <div className={styles.personalInformation}>
          <label>{fullName}</label>
          <label>{customer?.email}</label>
          {customer?.dateOfBirth && (
            <label className={styles.birthDate}>
              {t('LABEL_BIRTHDATE')}
              <span>{customer?.dateOfBirth}</span>
            </label>
          )}
        </div>
        <div className={styles.contactInformation}>
          {customerNumber && (
            <label>
              {t('LABEL_CUSTOMER_NUMBER')} <span>{customerNumber}</span>
            </label>
          )}
          {phone && (
            <label>
              {t('LABEL_PHONE')} <span>{phone}</span>
            </label>
          )}
          {renderCellPhone()}
        </div>
      </div>
      <div className={styles.footer}>
        <Link
          to={getRoutesUri('customerAccountInformationEdit') as string}
          className={styles.linkContainer}
        >
          <FontAwesomeIcon icon={faEdit} className={styles.editIcon} />
          <span className={styles.linkText}>
            {t('LABEL_INFORMATIONS_EDIT')}
          </span>
        </Link>
      </div>
    </Card>
  );
}

export default PersonalInformation;
